import { useState } from "react";
import { toast } from "sonner";
import { useShop } from "@/context/ShopContext";
import { api, errMsg } from "@/lib/api";
import useSeo from "@/lib/useSeo";

export default function Contact() {
  useSeo("Contact", "Get in touch with Maison Madison client care.");
  const s = useShop().settings || {};
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try { await api.post("/contact", form); setSent(true); } catch (err) { toast.error(errMsg(err)); }
    setLoading(false);
  };

  return (
    <div data-testid="contact-page" className="grid lg:grid-cols-12 gap-12 px-5 sm:px-10 lg:px-16 py-16 sm:py-24">
      <div className="lg:col-span-5">
        <p className="eyebrow text-[var(--mm-red)] mb-5 rise">Client care</p>
        <h1 className="font-serif-mm text-5xl sm:text-6xl leading-none rise d1">Write to <em>us.</em></h1>
        <p className="mt-6 text-sm text-[var(--mm-muted)] max-w-sm rise d2">For orders, sizing, styling or collaborations — we reply within two working days.</p>
        <div className="mt-12 space-y-6 text-sm rise d3">
          <div><p className="eyebrow mb-1">Email</p><a data-testid="contact-email-link" href={`mailto:${s.contact_email}`} className="hover:text-[var(--mm-red)]">{s.contact_email}</a></div>
          <div><p className="eyebrow mb-1">Instagram</p><a data-testid="contact-instagram-link" href={s.instagram_url} target="_blank" rel="noreferrer" className="hover:text-[var(--mm-red)]">{s.instagram_handle}</a></div>
          <div><p className="eyebrow mb-1">Hours</p><p>Monday – Friday, 9am – 5pm GMT</p></div>
        </div>
      </div>
      <div className="lg:col-span-6 lg:col-start-7">
        {sent ? (
          <div data-testid="contact-success" className="py-16 rise"><p className="font-serif-mm text-5xl">Thank you. <em className="text-[var(--mm-red)]">We'll be in touch.</em></p></div>
        ) : (
          <form onSubmit={submit} className="space-y-7">
            <input data-testid="contact-name-input" required placeholder="Your name" value={form.name} onChange={set("name")} className="field-mm" />
            <input data-testid="contact-email-input" required type="email" placeholder="Email address" value={form.email} onChange={set("email")} className="field-mm" />
            <input data-testid="contact-subject-input" placeholder="Subject" value={form.subject} onChange={set("subject")} className="field-mm" />
            <textarea data-testid="contact-message-input" required rows={6} placeholder="Your message" value={form.message} onChange={set("message")} className="field-mm resize-none" />
            <button data-testid="contact-submit-button" disabled={loading} className="btn-mm">{loading ? "Sending…" : "Send message"}</button>
          </form>
        )}
      </div>
    </div>
  );
}
